export default __webpack_public_path__ + "static/media/text.4dcbd3aa.svg";